<template lang="pug">
  CommonSection(:title="$route.params.taskId ? 'Редактирование задачи' : 'Новая задача'")
    template(#button)
      Btn(dark xl v-if="mode === 'edit'" @click="onCancelClick") Отмена
      Btn(dark xl v-else :to="{ name: 'project-stages', params: { ...$route.params } }") Вернуться к проекту
    .b-task-create(v-if="task")
      FormBlock._main
        ._top
          h2._title.-ordered Основное
          BaseSelect(:options="stagesOptions" v-model="task.stage" v-if="!task.isDraft" hideNotSelected @change="onInputChange()")
          BasePriority(editable v-model="task.priority" @change="onInputChange()")
        ._body
          BaseField(v-model="fields.name.value" v-bind="fields.name" @change="onInputChange('name')")
          WysiwygToolbar#toolbar
          WysiwygEditor(toolbar="#toolbar" label="Описание задачи" v-model="task.description" @change="onInputChange()" @dropFiles="additionalFiles = $event")
          CheckList(v-model="task.checklist" :id="task.id" @change="onInputChange()" editable)
          ProjectFileUploader(:selected="selectedFiles" @select="onFilesSelected" :filesToUpload="additionalFiles")
      ._aside
        FormBlock
          ._top
            h2._title Задача
            TaskStatus(
              v-model="task.status"
              @change="onInputChange()"
              :project="project"
              :changeable="access.canUpdateTask()"
              :editable="access.canEditProject()"
              @edited="$store.commit('project/setStatuses', $event);"
            )
          ._body.-task-aside
            UserUniversalTile._manager-select(editable v-model="task.manager" :items="$store.getters['project/members']" @change="onInputChange()" label="Нет исполнителя" emptyLabel="Нет участников проекта")
            BaseField(v-model="fields.dateStart.value" v-bind="fields.dateStart" @change="onInputChange('dateStart')")
            BaseField(v-model="fields.dateFinish.value" v-bind="fields.dateFinish" @change="onInputChange('dateFinish')")
        ._aside-footer
          Btn(green v-if="mode === 'create'" @click="onPublishClick") Создать задачу
          Btn(grey v-if="mode === 'edit'" @click="onCancelClick") Отмена
          Btn(green v-if="mode === 'edit'" @click="onSaveClick") Обновить задачу
      FormBlock._main
        ._top.-align-left
          h2._title.-ordered Наблюдатели
          BaseTooltip(text="Наблюдатели видят только те задачи, в которых принимают участие")
        UserSelectTile(v-model="task.members" :items="$store.getters['project/members']" @change="onInputChange()" multiple emptyLabel="Нет участников проекта")
      ._main
        ._bottom
          Btn(green v-if="mode === 'create'" @click="onPublishClick") Создать задачу
          Btn(grey v-if="mode === 'edit'" @click="onCancelClick") Отмена
          Btn(green v-if="mode === 'edit'" @click="onSaveClick") Обновить задачу
</template>

<script>
import taskApi from '@/api/task';

import form from '@/utils/form';

import CommonSection from '@/components/CommonSection.vue';
import BaseField from '@/components/BaseField.vue';
import FormBlock from '@/components/FormBlock.vue';
import BasePriority from '@/components/BasePriority.vue';
import WysiwygToolbar from '@/components/WysiwygToolbar.vue';
import WysiwygEditor from '@/components/WysiwygEditor.vue';
import ProjectFileUploader from '@/components/ProjectFileUploader.vue';
import BaseTooltip from '@/components/BaseTooltip.vue';
import TaskStatus from '@/components/task/TaskStatus.vue';
import UserSelectTile from '@/components/UserSelectTile.vue';
import UserSelectPopup from '@/components/UserSelectPopup.vue';
import UserUniversalTile from '@/components/UserUniversalTile.vue';
import CheckList from '@/components/checlkist/CheckList.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import Access from '@/utils/access';

export default {
  name: 'TaskForm',
  components: {
    BaseSelect,
    CommonSection,
    CheckList,
    UserUniversalTile,
    UserSelectPopup,
    TaskStatus,
    ProjectFileUploader,
    BaseField,
    BasePriority,
    FormBlock,
    WysiwygToolbar,
    WysiwygEditor,
    BaseTooltip,
    UserSelectTile,
  },
  data() {
    return {
      task: null,
      contacts: [],
      managerSelectPopupOpened: false,
      selectedFiles: [],
      fields: {
        name:       form.createFieldObject('text',     'Название задачи', '', { required: 'Укажите название задачи' }), // eslint-disable-line
        dateStart:  form.createFieldObject('datetime', 'Старт',           ''                                         ), // eslint-disable-line
        dateFinish: form.createFieldObject('datetime', 'Финиш',           ''                                         ), // eslint-disable-line
      },
      additionalFiles: [],
    };
  },
  computed: {
    currUser() { return this.$store.state.auth.user; },
    project() { return this.$store.state.project.project; },
    access() { return new Access({ ...this.task, project: this.project }, this.currUser); },
    mode() { return this.$route.params.taskId ? 'edit' : 'create'; },
    stagesOptions() {
      return this.$store.getters['stage/itemsHydrated'].map((p) => ({
        value: p['@id'],
        label: p.name,
      }));
    },
  },
  methods: {
    onFilesSelected(files) {
      this.selectedFiles = files;
      this.onInputChange();
    },
    onInputChange(fieldName) {
      form.validateField(this.fields, fieldName);

      if (this.mode === 'edit') {
        this.$store.commit('closePrevent/enable');
        return;
      }

      if (form.hasErrors(this.fields)) {
        return;
      }

      const formFata = {
        ...this.task,
        ...form.getValues(this.fields),
        projectFiles: this.selectedFiles,
        members: this.task.members.map((item) => item['@id']),
        manager: this.task.manager ? this.task.manager['@id'] : null,
      };

      delete formFata.author;

      taskApi.update(this.task.id, formFata);
    },
    onPublishClick() {
      // form.validate(this.fields);
      //
      // if (form.hasErrors(this.fields)) {
      //   return;
      // }
      //
      // taskApi.publish(this.task.id, true)
      //   .then(() => {
      //     this.$push({ text: 'Задача создана' });
      //     this.$router.push({
      //       name: 'task-detail',
      //       params: {
      //         ...this.$route.params,
      //         taskId: this.task.id,
      //       },
      //     });
      //   }).catch(e => console.log(e));
    },
    onSaveClick() {
      form.validate(this.fields);

      if (form.hasErrors(this.fields)) {
        return;
      }

      const formFata = {
        ...this.task,
        ...form.getValues(this.fields),
        projectFiles: this.selectedFiles,
        members: this.task.members.map((item) => item['@id']),
        manager: this.task.manager ? this.task.manager['@id'] : null,
      };

      delete formFata.author;

      taskApi.update(this.task.id, formFata, true)
        .then(r => {
          this.$store.commit('closePrevent/disable');
          this.$router.push({
            name: 'task-detail',
            params: {
              ...this.$route.params,
              stageId: r.stage.id, // stage might be updated
            },
          });
        });
    },
    onCancelClick() {
      this.$router.push({ name: 'task-detail', params: { ...this.$route.params } });
    },
    onTaskFetched(response) {
      this.task = response;
      this.task.stage = this.task.stage['@id'];
      this.selectedFiles = response.projectFiles.map((item) => item['@id']);
      document.title = this.mode === 'create' ? 'Новая задача' : response.name;

      if (this.mode === 'create' && !response.dateStart) {
        response.dateStart = new Date(); // eslint-disable-line no-param-reassign
      }

      form.setValues(this.fields, response);
    },
  },
  created() {
    const { taskId, stageId, projectId } = this.$route.params;

    if (this.mode === 'create') {
      // taskApi.fetchDraft(stageId, true).then(this.onTaskFetched);
    } else {
      taskApi.fetchItem(taskId, true).then(this.onTaskFetched);
    }

    this.$store.dispatch('project/fetchProject', { projectId });
  },
};
</script>

<style scoped lang="scss">
.task-create {
  display: grid;
  grid-template-columns: 1fr 1fr 336px;
  grid-column-gap: 40px;
  grid-row-gap: 30px;
  align-items: start;
  padding-bottom: 30px;

  &__main {
    grid-column: 2 span;
  }

  &__aside {
    grid-column: 1 span;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 32px;

    &--align-left {
      align-items: center;
      justify-content: flex-start;
    }
  }

  &__bottom {
    display: flex;
    justify-content: flex-end;
    gap: 30px;
  }

  &__aside-footer {
    display: flex;
    gap: 30px;
    margin-top: 30px;
  }

  &__title {
    font-size: 18px;
    color: var(--color-super-dark);
    margin-right: auto;

    &--ordered:before {
      content: counter(number);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 100%;
      counter-increment: number;
      margin-right: 16px;
      background-color: var(--color-super-light);
    }
  }

  &__body {
    display: grid;
    align-items: flex-start;
    column-gap: 30px;
    row-gap: 16px;
    margin-bottom: 9px;

    &--task-aside {
      gap: 8px;
    }
  }

  &__manager-select {
    margin-bottom: 28px;
  }

  @media (max-width: 1249px) {
    grid-template-columns: 1fr;
    grid-column-gap: 0;

    &__main {
      grid-column: 1 span;
    }

    &__aside {
      grid-column: 1 span;
    }

    &__aside-footer {
      display: none;
    }
  }

  @media (max-width: 1249px) and (min-width: 768px) {
    &__body--task-aside {
      grid-template-columns: calc(50% - 16px) 25% 25%;
    }

    &__manager-select {
      grid-column: 1 span;
      margin-right: 20px;
    }
  }

  @media (max-width: 900px) and (min-width: 768px) {
    &__body--task-aside {
      grid-template-columns: calc(60% - 16px) 20% 20%;
    }
  }
}
</style>
